import * as React from 'react';
import { createPortal } from 'react-dom';

export const PortalWrapper = ({ children }: { children: React.ReactNode }) => {
  const isBrowser = typeof window !== 'undefined';

  const portalRoot = isBrowser ? document.body : null;

  return isBrowser && portalRoot ? createPortal(children, portalRoot) : <>{children}</>;
};
